import { UiTextEnum } from '@bechtel/sr-types';
import { MultiLingualText } from '~/components/atoms';
import { useLanguage } from '~/components/molecules';

export const NoData = () => {
  const { getMultiLingualTextByKey } = useLanguage();
  return <MultiLingualText color="gray.800">{getMultiLingualTextByKey(UiTextEnum.NO_DATA_FOUND)}</MultiLingualText>;
};
